export default {
	data() {
		return {
			observer: null,
		}
	},

	unmounted() {
		this.observer?.disconnect();
	},

	methods: {
		registerWithObserver(htmlElement) {
			this.observer.observe(htmlElement);
		},

		unregisterFromObserver(htmlElement) {
			this.observer.unobserve(htmlElement);
		},

		intializeObserver(callback, options) {
			if (this.observer) {
				this.observer.disconnect();
			}
			// Add an intersectionobserver to ensure product cards are only tracked as they are viewed
			// Call this in the created lifecycle hook if you want child components
			// to be able to register themselves
			this.observer = new IntersectionObserver(
				callback,
				options,
			);
		},

		unregisterAllObservedItems() {
			if (!this.observer) return;

			this.observer.disconnect();
			this.observer = null;
		}
	}
};
